import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface LeadState {
  lead: string;
}

const initialState: LeadState = {
  lead: ""
};

export const leadSlice = createSlice({
  name: 'lead',
  initialState,
  reducers: {
    setLead: (state, action: PayloadAction<string>) => {
      state.lead = action.payload;
    },
    vaciarLead: (state) => {
      state.lead = "";
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  setLead,
  vaciarLead,
} = leadSlice.actions;

export default leadSlice.reducer;
